export * from './rate-agreement-bulk-upsert.model';